<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex v-bind="binding" v-if="isAutoCodeSerialization != 'ACTIVE' ">
                <v-text-field
                  name="code"
                  label="Code"
                  v-model="customer.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex v-bind="binding" v-if="isAutoCodeSerialization == 'ACTIVE' && customer.id ">
                <v-text-field
                  name="code"
                  label="Code"
                  v-model="customer.code"
                  type="text"
                  :rules="rules.customerCodeRules"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex mt-4 style="text-align:center;" sm6 v-if="customer.id" >
               <v-layout row>
                 <v-flex class="ml-3" xs4><span style="font-weight:bold;">Total Advanced Amount</span></v-flex>
                 <v-flex xs2 style="font-weight:bold;">:</v-flex>
                 <v-flex xs4 style="font-weight:bold;">{{customer.advancedAmount | decFormat(6)}}</v-flex>
               </v-layout>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Name"
                  v-model="customer.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="phoneNo"
                  label="PhoneNo"
                  v-model="customer.phoneNo"
                  type="text"
                  :rules="rules.phoneNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field name="email" label="Email" v-model="customer.email" type="text"></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="customer.cityId"
                  :items="cityList"
                  color="blue-grey lighten-2"
                  label="Choose City..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.cityIdRules"
                  @change="getTownshipByCityId(customer.cityId)"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="customer.townshipId"
                  :items="townshipList"
                  color="blue-grey lighten-2"
                  label="Choose Township..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.townshipIdRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="address"
                  label="Address"
                  v-model="customer.address"
                  type="text"
                  :rules="rules.addressRules"
                ></v-textarea>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="creditLevelList"
                  v-model="customer.creditLevelId"
                  label="Choose Credit Level"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.creditLevelRules"
                ></v-select>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="regionList"
                  label="Choose Region ..."
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  @change="changeRegion"
                  v-model="customer.regionId"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="priceModelList"
                  label="Choose Price Model ..."
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  v-model="customer.priceModelId"
                ></v-select>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Account Code"
                  v-model="customer.accountCode"
                  @click="showAccounts()"
                  :rules="rules.codeRules"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Account Name"
                  v-model="customer.accountName"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="customer.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="customer.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="customer.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="customer.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="customer.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="customer.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="customer.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-layout>
                <v-flex>
                  <v-flex sm12>
                    <v-btn color="success" @click="addMargin()" :disabled="addBtnDisabled">
                      Add Margin
                      <v-icon right>add</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-layout row wrap class="light--text">
                    <v-flex xs3>Level</v-flex>
                    <v-flex xs5>Name</v-flex>
                    <v-flex xs2>Percentage</v-flex>
                    <v-flex xs1>Action</v-flex>
                  </v-layout>
                  <v-layout row wrap v-for="(margin, index) in customer.marginList" :key="index">
                    <v-flex xs3>
                      <v-text-field
                        v-model="margin.level"
                        :loading="showAutocompleteLoading"
                        label="Level"
                        :rules="rules.levelRules"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5>
                      <v-text-field
                        v-model="margin.name"
                        :loading="showAutocompleteLoading"
                        label="Name"
                        :rules="rules.nameRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        v-model="margin.percentage"
                        type="number"
                        min="0"
                        max="100"
                        oninput="this.value = Math.abs(this.value)"
                        :loading="showAutocompleteLoading"
                        :rules="rules.percentageRules"
                        label="Percentage"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1>
                      <v-btn
                        icon
                        @click="removeMargin(index, margin.id)"
                        :disabled="customer.marginList.length != index+1"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <account-list-dialog
      :showDialog="accountListDialog"
      :params="{ isParent: false }"
      @close="closeAccountDialog"
    ></account-list-dialog>
  </v-container>
</template>

<script>
import { CustomerFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { customerService } from "../../services/customer-service";
import { creditLevelService } from "../../services/credit-level-service";
import { cityService } from "../../services/city-service";
import { commonService } from "../../services/common-service";
import { Customer, Margin } from "../../models/model";
import { regionService } from "../../services/region-service";
import { priceModelService } from "../../services/price-model-service";
import AccountListDialog from "../dialogs/AccountListDialog.vue";

export default {
  name: "CustomerDetail",
  components: { VSwitch, AccountListDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    isAutoCodeSerialization: JSON.parse(localStorage.getItem("AUTO_CODE_SERIALIZATION")),
    breadcrumbs: [
      {
        text: "Customers",
        disabled: false,
        to: "customers"
      },
      {
        text: "Customer Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    responseError: "",
    customer: new Customer(),
    oldCustomer: new Customer(),
    margin: new Margin(),
    rules: new CustomerFormRules(),
    accountListDialog: false,
    saveLoading: false,
    statusFlag: true,
    showAutocompleteLoading: false,
    addBtnDisabled: false,
    cancelBtnDisabled: false,
    creditLevelList: [],
    regionList: [],
    priceModelList: [],
    cityList: [],
    decimalFormat: "",
    townshipList: [],
    priceModelParams: {
      regionId: "",
      isExistRegion: false,
    }
  }),
  computed: {
    binding() {
    const binding = {};
      if(this.customer.id){
        binding.sm6 = true;
      }
      else binding.sm12 = true;
      return binding;
    }
  },
  created() {
    const id = this.$route.params.id;
    this.getCreditLevels();
    if (id == "new") {
      // new Customer
      this.addMargin();
    } else {
      this.getCustomerDetail(id);
    }
    this.getAllCity();
    this.decimalFormat = commonService.formatdecimal();
    this.getRegionList();
    this.getPriceModelList();
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.customer.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        if(this.customer.code == ''){
            this.customer.code = null;
        }
        customerService
          .saveCustomer(this.customer)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getCustomerDetail(id) {
      customerService
        .getCustomerDetail(id)
        .then(res => {
          this.customer = res.data;
          if(this.customer.regionId){
          this.priceModelParams.isExistRegion = true;
          this.priceModelParams.regionId = this.customer.regionId;
          } else{
          this.priceModelParams.isExistRegion = false;
          this.customer.regionId = "";
          }
          this.getPriceModelList();
          if (!this.customer.priceModelId) this.customer.priceModelId = "";
          this.getTownshipByCityId(this.customer.cityId);
          this.customer.townshipId = res.data.townshipId;
          this.createdDate = commonService.formatDate(
            new Date(this.customer.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.customer.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          this.oldCustomer = Object.assign({}, res.data);
          this.statusFlag = this.customer.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then(res => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllCity() {
      cityService.getAllCity().then(res => {
        this.cityList = res.data.cityList;
      });
    },
    getRegionList() {
      regionService
        .getRegionsByStatus("ACTIVE")
        .then(res => {
          this.regionList = res.data;
          let noregion = {
            id: "",
            name: "----No Region----"
          };
          this.regionList.splice(0, 0, JSON.parse(JSON.stringify(noregion)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    changeRegion(){
    this.priceModelParams.regionId = this.customer.regionId;
    if(this.customer.regionId){
      this.priceModelParams.isExistRegion = true;
    } else{
      this.priceModelParams.isExistRegion = false;
    }
    this.getPriceModelList();
    },

    getPriceModelList(){
      priceModelService.getAllPriceModelList(this.priceModelParams)
      .then(res => {
          this.priceModelList = res.data.data;
          let nopricemodel = {
            id: "",
            name: "----No Price Model----"
          };
          this.priceModelList.splice(0, 0, JSON.parse(JSON.stringify(nopricemodel)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTownshipByCityId(cityId) {
      cityService
        .getCityDetail(cityId)
        .then(res => {
          this.townshipList = res.data.townships;
        })
        .catch(err => {
          console.log(err);
        });
    },

    addMargin() {
      // deep copy
      margin = new Margin();
      if (this.customer.marginList.length == 0) {
        this.margin.level = 1;
      } else {
        this.margin.level = this.customer.marginList.length + 1;
      }
      let margin = JSON.parse(JSON.stringify(this.margin));
      this.customer.marginList.push(margin);
      if (this.customer.marginList.length == 3) this.addBtnDisabled = true;
    },

    removeMargin(index, marginId) {
      if (marginId) {
        // add delete stock in id
        if (!this.customer.deleteMarginIds) {
          this.customer.deleteMarginIds = [];
        }
        this.customer.deleteMarginIds.push(marginId);
      }
      this.$delete(this.customer.marginList, index);
      if (this.customer.marginList.length != 3) {
        this.addBtnDisabled = false;
      }
      if (this.customer.marginList.length == index) {
        this.cancelBtnDisabled = false;
      }
    },

    showAccounts() {
      this.accountListDialog = !this.accountListDialog;
    },
    closeAccountDialog(account) {
      this.accountListDialog = !this.accountListDialog;
      if (account.id) {
        this.customer.accountId = account.id;
        this.customer.accountCode = account.code;
        this.customer.accountName = account.name;
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.customer.id) {
        this.customer = new Customer();
        this.statusFlag = true;
      } else {
        this.customer = Object.assign({}, this.oldCustomer);
        this.statusFlag = this.customer.status == "ACTIVE" ? true : false;
      }
      if (this.customer.marginList.length == 3) this.addBtnDisabled = true;
    },
    goBack() {
      this.$router.push("/customers");
    }
  }
};
</script>

